// extracted by mini-css-extract-plugin
export default {"imageBox":"styles_imageBox__M1KSn"};